import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('APP', {
  FETCH_COOKIES:   null,
  LOAD_APP_CONFIG: null,
  LOAD_COOKIES:    null,
  SHOW_ERROR_PAGE: null,
  UPDATE_FEATURE_FLAG_REQUEST: null,
  UPDATE_FEATURE_FLAG_SUCCESS: null,
  UPDATE_FEATURE_FLAG_FAILURE: null
});



// WEBPACK FOOTER //
// ./app/constants/AppConstants.js